module.exports = __webpack_public_path__ + "img/meat.b4335d12.svg";